import { ExtendedUserField, GroupField } from 'components';
import { ReactElement } from 'react';
import { LazyQuotaDisplay } from 'modules/core/hub/lazy';
import { useField } from 'react-final-form';
import { UserOrInvite } from './UserOrInvite';

export function Form(): ReactElement {
  const {
    input: { value: id },
  } = useField('id', { subscription: { value: true } });

  return (
    <div className="row">
      <div className="col-md-6">
        {!id && <LazyQuotaDisplay />}
        {id ? <ExtendedUserField name="user" placeholder="User" required disabled /> : <UserOrInvite />}
        <GroupField name="groups" label="Roles" required isMulti help="Type to find a specific agency role" />
      </div>
    </div>
  );
}
